module.exports = __webpack_public_path__ + "img/basic.a36832a1.png";